<template>
  <parent>
    <loading-page v-if="loading" />
    <lifecycle-form
      v-else
      details
      :edited-settings="settings"
      @close="cancel"
      @save="save"
    />
  </parent>
</template>
<script>
import LifecycleForm from './Form.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'EditLifecycle',
  components: { LifecycleForm },
  data() {
    return {
      bucketName: null,
      lifecycleId: null,
      settings: {
        name: '',
        tags: [],
        prefix: '',
        ruleScope: 0,
        ruleAction: [],
        currentTransitionTags: [
          {
            index: 0,
            rule: 'COLD',
            days: null,
          },
        ],
        noncurrentTransitionTags: [
          {
            index: 0,
            rule: 'COLD',
            days: null,
            versions: null,
          },
        ],
        expirationDaysCurrentVersion: null,
        expirationDaysNoncurrentVersion: null,
        verisonsNoncurrentVersion: null,
        expiredObjectDeleteMarker: null,
        deleteIncompleteMultipartUploads: null,
        daysAfterInitiation: null,
        selectedFilter: 'prefix',
      },
      accountId: 0,
    }
  },
  computed: {
    loading() {
      return this.$store.state.accountLifecycle.gettingLifecycle
    },
    lifecycle() {
      return this.$store.state.accountLifecycle.lifecycle
    },
    bucketId() {
      return this.$route.params.id
    },
  },
  created() {
    this.accountId = this.$route.params.accountId
    this.lifecycleId = this.$route.params.lifecycleId
    this.$store
      .dispatch('accountLifecycle/getLifecycle', {
        accountId: this.accountId,
        query: {
          name: this.bucketId,
          id: this.lifecycleId,
        },
      })
      .then(() => {
        this.settings.name = this.lifecycle.id

        if (this.lifecycle.prefixFilter?.prefix) {
          this.settings.prefix = this.lifecycle.prefixFilter.prefix
        }

        if (this.lifecycle.tagFilter?.tag) {
          this.settings.tag = this.lifecycle.tagFilter.tag
          this.settings.selectedFilter = 'tag'
        }

        this.settings.ruleScope = this.lifecycle.prefixFilter || this.lifecycle.tagFilter ? 0 : 1

        if (
          this.lifecycle.transitions
          && this.lifecycle.transitions.length > 0
        ) {
          if (!this.settings.ruleAction.includes(0)) {
            this.settings.ruleAction.push(0)
          }
          this.settings.currentTransitionTags = []
          this.lifecycle.transitions.forEach((el, index) => {
            this.settings.currentTransitionTags.push({
              index,
              rule: el.storageClass.value,
              days: el.days,
            })
          })
        }

        if (
          this.lifecycle.noncurrentVersionTransitions
          && this.lifecycle.noncurrentVersionTransitions.length > 0
        ) {
          if (!this.settings.ruleAction.includes(1)) {
            this.settings.ruleAction.push(1)
          }
          this.settings.noncurrentTransitionTags = []
          this.lifecycle.noncurrentVersionTransitions.forEach((el, index) => {
            this.settings.noncurrentTransitionTags.push({
              index,
              rule: el.storageClass.value,
              days: el.noncurrentDays,
              versions: el.newerNoncurrentVersions || null,
            })
          })
        }

        if (this.lifecycle.expiration?.days) {
          this.settings.expirationDaysCurrentVersion = this.lifecycle.expiration.days
          if (!this.settings.ruleAction.includes(2)) {
            this.settings.ruleAction.push(2)
          }
        }

        if (this.lifecycle.noncurrentVersionExpiration?.noncurrentDays) {
          if (!this.settings.ruleAction.includes(3)) {
            this.settings.ruleAction.push(3)
          }
          this.settings.expirationDaysNoncurrentVersion = this.lifecycle.noncurrentVersionExpiration.noncurrentDays
          this.settings.verisonsNoncurrentVersion = this.lifecycle.noncurrentVersionExpiration
            .newerNoncurrentVersions || null
        }

        if (
          this.lifecycle.abortIncompleteMultipartUpload?.daysAfterInitiation
        ) {
          this.settings.daysAfterInitiation = this.lifecycle.abortIncompleteMultipartUpload.daysAfterInitiation
          this.settings.deleteIncompleteMultipartUploads = true
          if (!this.settings.ruleAction.includes(4)) {
            this.settings.ruleAction.push(4)
          }
        }
        if (this.lifecycle.expiration?.expiredObjectDeleteMarker) {
          this.settings.expiredObjectDeleteMarker = true
          if (!this.settings.ruleAction.includes(4)) {
            this.settings.ruleAction.push(4)
          }
        }
      })
      .catch(err => redirectError(err))
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'bucket-settings', id: this.bucketId })
    },
    save(lifecycle) {
      this.$store
        .dispatch('accountLifecycle/updateLifecycle', {

          accountId: this.accountId,
          query: {
            name: this.bucketId,
            lifecycle,
          },
        })
        .then(() => {
          this.cancel()
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while adding lifecycle rule.',
          )
        })
    },
  },
}
</script>
